import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const getAdminModelUnitEndpoint = (projectId: string, unitId: string, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/model-units/${unitId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createQuotationAdminEndpoint = (projectId: string, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string, data: any) =>
      axios({
        method: 'POST',
        url: `${urlService}/pre-sales/v1/admin/projects/${projectId}/quotations-v2`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data, // Agregar el data al request
      }),
    controller,
  };
};

export const getQuotationConfig = (
  token: string = '',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) => {
      //console.log('getCancellationReasons urlService:', urlService); // <-- imprime la url base
      return axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/quotation-config`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
    },
    controller,
  };
};
